// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  
  .dropdown .arrow {
    border-color: #999 transparent transparent;
    border-style: solid;
    border-width: 5px 5px 0;
    content: " ";
    display: block;
    height: 0;
    margin-top: 0.3rem;
    position: absolute;
    right: 10px;
    top: 14px;
    width: 0;
  }
  
  .dropdown .arrow.open {
    border-color: transparent transparent #999;
    border-width: 0 5px 5px;
  }
  
  .dropdown .selected-value input {
    /* line-height: 1.5; */
    /* font-size: 1rem; */
    /* border: 1px solid #ccc; */
    /* border-radius: 2px; */
    /* box-sizing: border-box; */
    cursor: default;
    outline: none;
    /* padding: 8px 52px 8px 10px; */
    transition: all 200ms ease;
    /* width: 100%; */
  }
  
  .dropdown .options {
    display: none;
    position: absolute;
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
    /* box-sizing: border-box; */
    margin-top: -1px;
    max-height: 200px;
    overflow-y: auto;
    top: 100%;
    width: 100%;
    z-index: 1;
    -webkit-overflow-scrolling: touch;
  }
  
  .dropdown .options.open {
    display: block;
  }
  
  .dropdown .option {
    box-sizing: border-box;
    color: rgba(51, 51, 51, 0.8);
    cursor: pointer;
    display: block;
    padding: 8px 10px;
  }
  
  .dropdown .option.selected,
  .dropdown .option:hover {
    background-color: #f2f9fc;
    color: #333;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/SearchDropDown.css"],"names":[],"mappings":";;EAEE;IACE,0CAA0C;IAC1C,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,0CAA0C;IAC1C,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,4BAA4B;IAC5B,wBAAwB;IACxB,4BAA4B;IAC5B,eAAe;IACf,aAAa;IACb,gCAAgC;IAChC,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,uCAAuC;IACvC,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,UAAU;IACV,iCAAiC;EACnC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,4BAA4B;IAC5B,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;;IAEE,yBAAyB;IACzB,WAAW;EACb","sourcesContent":["\n  \n  .dropdown .arrow {\n    border-color: #999 transparent transparent;\n    border-style: solid;\n    border-width: 5px 5px 0;\n    content: \" \";\n    display: block;\n    height: 0;\n    margin-top: 0.3rem;\n    position: absolute;\n    right: 10px;\n    top: 14px;\n    width: 0;\n  }\n  \n  .dropdown .arrow.open {\n    border-color: transparent transparent #999;\n    border-width: 0 5px 5px;\n  }\n  \n  .dropdown .selected-value input {\n    /* line-height: 1.5; */\n    /* font-size: 1rem; */\n    /* border: 1px solid #ccc; */\n    /* border-radius: 2px; */\n    /* box-sizing: border-box; */\n    cursor: default;\n    outline: none;\n    /* padding: 8px 52px 8px 10px; */\n    transition: all 200ms ease;\n    /* width: 100%; */\n  }\n  \n  .dropdown .options {\n    display: none;\n    position: absolute;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n    /* box-sizing: border-box; */\n    margin-top: -1px;\n    max-height: 200px;\n    overflow-y: auto;\n    top: 100%;\n    width: 100%;\n    z-index: 1;\n    -webkit-overflow-scrolling: touch;\n  }\n  \n  .dropdown .options.open {\n    display: block;\n  }\n  \n  .dropdown .option {\n    box-sizing: border-box;\n    color: rgba(51, 51, 51, 0.8);\n    cursor: pointer;\n    display: block;\n    padding: 8px 10px;\n  }\n  \n  .dropdown .option.selected,\n  .dropdown .option:hover {\n    background-color: #f2f9fc;\n    color: #333;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
